import React, { useReducer } from "react";
import tenantsReducer from "./tenantsReducer";
import tenantsContext from "./tenantsContext";

import {
    getAllTenants as getAllTenantsAPI,
    addTenant as addTenantAPI,
    updateTenant as updateTenantAPI,
    deleteTenant as deleteTenantAPI,
    getTenantStats as getTenantStatsAPI
} from "../../api/tenant";

import {
    GET_TENANTS,
    ADD_TENANT,
    UPDATE_TENANT,
    DELETE_TENANT,
    SET_LOADING,
    SET_ERROR,
    GET_TENANT_STATS
} from "./tenantsActions";

const TenantsState = props => {

    const initialState = {
        tenants: [],
        stats: null,
        loading: false,
        error: null
    };

    const [state, dispatch] = useReducer(tenantsReducer, initialState);

    const getAllTenants = async () => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await getAllTenantsAPI();
            dispatch({
                type: GET_TENANTS,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en getAllTenants", error);
            dispatch({ type: SET_ERROR, payload: error.message });
        }
    };

    const addTenant = async (tenant) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await addTenantAPI(tenant);
            dispatch({
                type: ADD_TENANT,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en addTenant", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const updateTenant = async (tenant) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await updateTenantAPI(tenant);
            dispatch({
                type: UPDATE_TENANT,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en updateTenant", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const deleteTenant = async (tenant) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await deleteTenantAPI(tenant);
            dispatch({
                type: DELETE_TENANT,
                payload: tenant
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en deleteTenant", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const getTenantStats = async () => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await getTenantStatsAPI();
            dispatch({
                type: GET_TENANT_STATS,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en getTenantStats", error);
            dispatch({ type: SET_ERROR, payload: error.message });
        }
    };

    return (
        <tenantsContext.Provider
            value={{
                tenants: state.tenants,
                stats: state.stats,
                loading: state.loading,
                error: state.error,
                getAllTenants,
                addTenant,
                updateTenant,
                deleteTenant,
                getTenantStats
            }}
        >
            {props.children}
        </tenantsContext.Provider>
    );
};

export default TenantsState;
